//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "PNSC",
  data() {
    return {
      form: {
        f1: "",
        f2: "",
        f3: "",
      },
      hasScore: false,
      disabled: false,
      dataList1: [
        { value: "0", name: "流行病学定义的表型与肿瘤无关" },
        { value: "2", name: "中风险表型" },
        { value: "3", name: "高风险表型" },
      ],
      dataList2: [
        { value: "0", name: "低风险抗体(<30%与肿瘤相关)或阴性" },
        { value: "2", name: "中风险抗体(30%~70%与肿瘤相关)" },
        { value: "3", name: "高风险抗体(>70%与肿瘤相关)" },
      ],
      dataList3: [
        { value: "0", name: "未发现肿瘤,且已随访>2年" },
        {
          value: "1",
          name: "未发现肿瘤（或与表型和存在抗体不一致）但随访<2年",
        },
        {
          value: "4",
          name: "发现肿瘤,且与表型和存在的抗体一致,或不一致但已证实抗原表达",
        },
      ],
    };
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      let result = 0;
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            form[key] = Number(form[key]);
          }
        }
        result += Number(form[key]);
      }
      console.log(result);
      if (!flag) {
        self.hasScore = false;
        return "";
      } else {
        self.hasScore = true;
        return String(result);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Neuro/PNSC.vue